import { DateTime } from "luxon";
import { WEB_STORAGE_KEYS } from "./clients.constants";
const { ALERTS_DATE_FILTERS, ALERTS_SELECTED_DATE } = WEB_STORAGE_KEYS;

const getDefaultAlertsDateFilters = () => {
  // Today's start: 00:00:00, and tomorrow's start: 00:00:00 (as the end)
  const todayStart = DateTime.local().startOf("day");
  const tomorrowStart = DateTime.local().plus({ days: 1 }).startOf("day");
  return [todayStart.toISO(), tomorrowStart.toISO()];
};

class WebStorage {
  getAlertsDateFilters({ forReducer = false } = {}) {
    let res = [null, null];
    const stored = localStorage.getItem(ALERTS_DATE_FILTERS);
    let dateFilters = null;
    try {
      dateFilters = JSON.parse(stored);
    } catch (e) {
      dateFilters = null;
    }

    // If there are no stored date filters, set the default values in localStorage
    if (!dateFilters) {
      const defaultFilters = getDefaultAlertsDateFilters();
      localStorage.setItem(ALERTS_DATE_FILTERS, JSON.stringify(defaultFilters));
      return forReducer
        ? defaultFilters
        : [new Date(defaultFilters[0]), new Date(defaultFilters[1])];
    }

    const [fromIsoString, toIsoString] = dateFilters;
    const fromValid = DateTime.fromISO(fromIsoString).isValid;
    const toValid = DateTime.fromISO(toIsoString).isValid;

    if (fromValid && toValid) {
      res = forReducer
        ? [fromIsoString, toIsoString]
        : [new Date(fromIsoString), new Date(toIsoString)];
    } else {
      // If stored values are invalid, use and store the defaults.
      const defaultFilters = getDefaultAlertsDateFilters();
      localStorage.setItem(ALERTS_DATE_FILTERS, JSON.stringify(defaultFilters));
      res = forReducer
        ? defaultFilters
        : [new Date(defaultFilters[0]), new Date(defaultFilters[1])];
    }

    return res;
  }

  getAlertSelectedDate({ forReducer = false } = {}) {
    let dateString = localStorage.getItem(ALERTS_SELECTED_DATE);

    if (!dateString) {
      return null;
    }
    dateString = dateString.replace(/^"|"$/g, "");
    return dateString;
  }

  getByKey(key) {
    let res = null;

    const alertsFilters = JSON?.parse(localStorage?.getItem(key));

    if (alertsFilters) {
      res = alertsFilters;
    }

    return res;
  }

  getDrawerOpened() {
    const res = localStorage.getItem(WEB_STORAGE_KEYS.DRAWER_OPENED);

    if (res === null) {
      return true;
    }

    return JSON.parse(res);
  }

  removeAllKeys() {
    const keysToKeep = [];

    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);

      if (!keysToKeep.includes(key)) {
        localStorage.removeItem(key);
      }
    }
  }
}

export const WebStorageClient = new WebStorage();

